import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import ErrorBoundaryWithPropagation from "@components/boundary/ErrorBoundaryWithPropagation";

export default observer(function OneClickBetNotification() {
	const rootStore = useRootAppStore();
	const { t } = useTranslation();

	if (
		!rootStore.betSlipStore.isOneClickBetActive ||
		!rootStore.userAuthStore.isLoggedIn
	) {
		return null;
	}

	return (
		<ErrorBoundaryWithPropagation
			componentName={"Desktop/OneClickBetNotification.tsx"}
		>
			<div className="message--oneclick card--shadowy is-active">
				<div className="message--oneclick__title">
					<i className="u-icon u-icon--lrg u-icon--one-click u-color--sent--success u-align--v--middle u-mar--right--xsml" />
					<span className="u-align--v--middle">
						{t<string>("BET_SLIP.ONE_CLICK_BET.ACTIVE_MESSAGE")}
					</span>
				</div>
				<div className="u-type--sml u-mar--bottom--xsml">
					{t<string>("BET_SLIP.ONE_CLICK_BET.ALERT")}
				</div>
				<button
					className="btn btn--sml btn--primary--inverted u-color--sent--danger"
					onClick={rootStore.betSlipStore.onDeactivateOneClickBet}
					disabled={rootStore.betSlipStore.isSubmitting}
				>
					{t<string>("BET_SLIP.ONE_CLICK_BET.DEACTIVATE")}
				</button>
			</div>
		</ErrorBoundaryWithPropagation>
	);
});
